import React from "react";

const Footer = () => {
  return <div className="mb-10"></div>;
};

export default Footer;
